export default theme => ({
  link: {
    textDecoration: "none",
    color: theme.palette.link.dark,
    whiteSpace: "pre-wrap",
  },
});
